import { FC } from 'react'
import { Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'

const MensajePagoIncorrecto: FC = () => {
  return (
    <>
      {/* begin::Title */}
      <h1 className='fw-bolder fs-2qx text-gray-900 mb-4'>Pago Cancelado!</h1>
      {/* end::Title */}

      {/* begin::Text */}
      <div className='fw-semibold fs-6 text-gray-500 mb-7'>
        Inténtelo de nuevo.
      </div>
      {/* end::Text */}

      {/* begin::Illustration */}
      <div className='mb-11'>
        <img
          src={toAbsoluteUrl('/media/mensajePagado/incorrecto.png')}
          className='mw-100 mh-100px theme-light-show'
          alt=''
        />
        <img
          src={toAbsoluteUrl('/media/mensajePagado/incorrecto.png')}
          className='mw-100 mh-100px theme-dark-show'
          alt=''
        />
      </div>
      {/* end::Illustration */}

      {/* begin::Link */}
      <div className='mb-0'>
        <Link to='/apps/ordenes-management/' className='btn btn-sm btn-primary'>
          Regresar a Ordenes
        </Link>
      </div>
      {/* end::Link */}
    </>
  )
}

export { MensajePagoIncorrecto }
